import React from "react";
import { Link } from "react-router-dom";

// Three variants only (design system §8). Anything that looks like a button
// should be one of these — no more one-off hex fills like Login's #3d63b4.
const VARIANTS = {
  primary:
    "bg-primary text-white hover:bg-primary-hover disabled:bg-primary/50 shadow-sm",
  secondary:
    "bg-surface text-navy border border-border-strong hover:bg-bg disabled:opacity-50",
  tertiary:
    "text-primary hover:text-primary-hover px-0 h-auto font-semibold disabled:opacity-50",
  ghost: "text-navy hover:bg-bg disabled:opacity-50",
  danger: "bg-danger text-white hover:bg-danger/90 disabled:opacity-50",

  // For navy and gradient panels. A white fill with navy text carries far more
  // weight against a dark ground than the blue primary, which nearly
  // disappears into it.
  inverse:
    "bg-white text-navy hover:bg-white/90 shadow-sm disabled:opacity-60 focus-visible:ring-white/60",
  // The quieter partner to `inverse`, for a secondary action on the same panel.
  "inverse-outline":
    "border border-white/35 text-white hover:bg-white/10 hover:border-white/60 disabled:opacity-60 focus-visible:ring-white/60",
};

const SIZES = {
  sm: "h-9 px-3 text-sm",
  md: "h-11 px-5 text-sm", // 44px — the design system's default control height
  lg: "h-12 px-6 text-base",
};

const Button = ({
  variant = "primary",
  size = "md",
  to,
  href,
  className = "",
  children,
  ...props
}) => {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 disabled:cursor-not-allowed";
  const classes = `${base} ${VARIANTS[variant] ?? VARIANTS.primary} ${
    variant === "tertiary" ? "" : SIZES[size] ?? SIZES.md
  } ${className}`;

  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={classes} {...props}>
        {children}
      </a>
    );
  }
  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
};

export default Button;
